import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember} from 'typedjson';

@jsonObject
export class HardwareInfo {
  @jsonMember({name: 'productName'})
  public ProductName!: string;

  @jsonMember({name: 'productType'})
  public ProductType!: string;

  @jsonMember({name: 'internalMemorySize'})
  public InternalMemorySize!: number;

  @jsonMember({name: 'ramSize'})
  public RamSize!: number;

  @jsonMember({name: 'hardwareVersion'})
  public HardwareVersion!: string;

  @jsonMember({name: 'secondaryFirmwareVersion'})
  public SecondaryFirmwareVersion!: string;
}
